export default function OrderHeader() {
  return (
    <div className="sticky top-0 z-10 bg-gray-50 px-2 py-2 text-xs md:text-sm font-bold text-gray-700 border border-gray-200 grid grid-cols-12 gap-2">
      <div className="col-span-2">Customer</div>
      <div className="col-span-2">Client</div>
      <div className="col-span-1">Order ID</div>
      <div className="col-span-1">Order Date</div>
      <div className="col-span-1">Time Left</div>
      <div className="col-span-1">Order Type</div>
      <div className="col-span-1">Status</div>
      <div className="col-span-1">Payment</div>
      <div className="col-span-1">Payment Status</div>
      <div className="col-span-1">Order Status</div>

    </div>
  );
}
